import Dexie from 'dexie'

const db = new Dexie('tomatobrixup')

db.version(6).stores({
  farm: 'code, name, created, changed',
  cultivo: 'code, farm, name, type, created, changed, active',
  lancamento: 'code, sol_base, ec_base, ec_em_uso, ec_desejado, ec_cheia_atual, ec_ajustado_compl, ec_ajustado_macro, created, changed, active, cultivo',
  teste: 'code, active'
})

export default db
